export enum hygieneMicrocopy {
  HYGIENE_EMAIL_CAR_ALERT_UNSUBSCRIBE_CONTENT = 'HYGIENE_EMAIL_CAR_ALERT_UNSUBSCRIBE_CONTENT',
  HYGIENE_EMAIL_CAR_ALERT_UNSUBSCRIBE_TITLE = 'HYGIENE_EMAIL_CAR_ALERT_UNSUBSCRIBE_TITLE',
  HYGIENE_EMAIL_DEFAULT_UNSUBSCRIBE_TITLE = 'HYGIENE_EMAIL_DEFAULT_UNSUBSCRIBE_TITLE',
  HYGIENE_EMAIL_UNSUBSCRIBE_BUTTON_LABEL = 'HYGIENE_EMAIL_UNSUBSCRIBE_BUTTON_LABEL',
  HYGIENE_EMAIL_UNSUBSCRIBE_TITLE = 'HYGIENE_EMAIL_UNSUBSCRIBE_TITLE',
  HYGIENE_EMAIL_UNSUBSCRIBE_WATCHLIST_VEHICLE_AVAILABLE_TITLE = 'HYGIENE_EMAIL_UNSUBSCRIBE_WATCHLIST_VEHICLE_AVAILABLE_TITLE',
  HYGIENE_FINANCE_CALCULATOR_INPUT_LABEL_1 = 'HYGIENE_FINANCE_CALCULATOR_INPUT_LABEL_1',
  HYGIENE_FINANCE_CALCULATOR_INPUT_LABEL_2 = 'HYGIENE_FINANCE_CALCULATOR_INPUT_LABEL_2',
  HYGIENE_FINANCE_CALCULATOR_INPUT_LABEL_3 = 'HYGIENE_FINANCE_CALCULATOR_INPUT_LABEL_3',
  HYGIENE_FINANCE_CALCULATOR_LOAN_TITLE = 'HYGIENE_FINANCE_CALCULATOR_LOAN_TITLE',
  HYGIENE_FINANCE_CALCULATOR_LOAN_TITLE_ESTIMATED_BORROW_AMOUNT = 'HYGIENE_FINANCE_CALCULATOR_LOAN_TITLE_ESTIMATED_BORROW_AMOUNT',
  HYGIENE_FINANCE_CALCULATOR_LOAN_TITLE_ESTIMATED_REPAYMENT = 'HYGIENE_FINANCE_CALCULATOR_LOAN_TITLE_ESTIMATED_REPAYMENT',
  HYGIENE_FINANCE_CALCULATOR_TITLE = 'HYGIENE_FINANCE_CALCULATOR',
  HYGIENE_FINANCE_CALCULATOR_WEEKLY_FEE = 'HYGIENE_FINANCE_CALCULATOR_WEEKLY_FEE',
  HYGIENE_WHAT_HAPPENS_NEXT_DESCRIPTION = 'HYGIENE_WHAT_HAPPENS_NEXT_DESCRIPTION',
  HYGIENE_WHAT_HAPPENS_NEXT_TITLE = 'HYGIENE_WHAT_HAPPENS_NEXT_TITLE',
  HYGIENE_WHY_CARMA_CTA = 'HYGIENE_WHY_CARMA_CTA',
}
